jQuery(function () {
  var selectors = {
    container: '[data-behaviour~="toggle-group-container"]',
    trigger: '[data-behaviour~="toggle-group"]',
  };

  // BEHAVIOUR

  jQuery(document).on("click", selectors.trigger, clickHandler);

  // EVENTS HANDLERS

  function clickHandler(event) {
    var container = jQuery(this).closest(selectors.container);
    if (!container.length) {
      container = document;
    }

    toggleNext(container, jQuery(this).data("toggle-group-name"));
    return false;
  }

  // HELPER FUNCTIONS

  function toggleNext(container, groupName) {
    var groupMembers = jQuery(container)
      .find('[data-toggle-group-name~="' + groupName + '"]')
      .not(selectors.trigger);
    var toggled = -1;

    groupMembers.each(function (index, member) {
      if (jQuery(member).css("display") !== "none") {
        toggled = index;
      }
      toggle(member, false);
    });

    toggle(groupMembers[(toggled + 1) % groupMembers.length], true);
  }

  function toggle(member, show) {
    jQuery(member).toggle(show).find(Form.FORM_CONTROL_SELECTOR).attr("disabled", !show);
  }
});
